import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'

import { IToggleButtons } from './models/IToggleButtons'

export const ToggleButtons = ({ items, value, onChange, disabled }: IToggleButtons) => {
  return (
    <Flex>
      {items.map((item) => {
        return (
          <Button
            {...item}
            disabled={disabled}
            key={item.key}
            variant={value === item.key ? 'contained' : 'outlined'}
            onClick={() => onChange(item.key, item)}
          >
            {item.text}
          </Button>
        )
      })}
    </Flex>
  )
}
